<template>

    <div class="container-center">

        <el-alert title="" type="success" :closable="false" style="margin-top:20px;">
            {{ bidData.inviteProjectEntry.fcurprojectname + ( bidData.inviteProjectEntry.fbidnum ? '-'+ bidData.inviteProjectEntry.fbidnum : '' ) }}
        </el-alert>

        <!-- bidData 信息 -->
        <el-card class="box-card">

            <div slot="header" class="clearfix">
                <div>{{ bidData.inquiryTital || '#缺省#' }} <span style="float:right;">截止时间：{{ bidData.inquiryEndDate }}</span></div>
            </div>

            <div style="padding:20px;">

                <el-row>
                    <p>致：{{ bidData.supplierName }}</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{{ bidData.businessInquiryContent }}</p>
                </el-row>

                <el-row style="margin-top:30px;">
                    <el-col :span="2" class="text-right">附件：</el-col>
                    <el-col :span="22">
                        <div v-if="bidData.baseFileList.length==0" class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in bidData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                        </ul>
                    </el-col>
                </el-row>

                <p style="text-align:right;">大华集团</p>
                <p style="text-align:right;">{{ (bidData.inquiryDate||'0000-00-00').substring(0,10) }}</p>

            </div>

        </el-card>


        <!-- type 0 -->
        <el-card v-if="type==0" class="box-card">
            <div slot="header" class="clearfix">
                <label>商务标询标记录</label>
                <el-button type="primary" size="mini" :disabled="!buttonFlag" style="float:right;" @click="addbussness()">+ 询标</el-button>
            </div>
            <div v-if="bidData.bidReturnList.length==0" class="no-data-tip"></div>
            <ul v-else class="invite-mng-list">
                <li v-for="(li,index) in bidData.bidReturnList"><span style="color: red;margin-right: 20px;">{{li.disReturn}}</span><a @click="(li.isDraft==1)?draftBidBusi(li):showBidBusiList(li.id)" href="javascript:;">{{ bidData.inviteProject.fname }} 商务标</a> <el-tag  v-if="li.isDraft==1" type="warning" size="mini">草稿</el-tag><span v-if="index!=0"  style="float:right;color: red;margin-left: 20px;cursor:pointer" @click="deleteXb(li.id,li.inquiryId)">删除</span><span style="float: right;">{{ li.createDate }}</span></li>
            </ul>
        </el-card>

        <el-dialog :title="inviteCompanyName +'商务询标'+ new Date().getDatetime().substring(0,10).replace(/-/g,'')"
                   :visible.sync="bidBusiDialogShow" fullscreen @close="resetForm()" center>
            <template v-if="iframeUrl && (isDraft ? draftId : busiUUID)">
                <iframe style="width:100%;height:900px;border:1px solid #ccc;" name="iframeA" id="iframeA"
                        :src="iframeUrl
                        +'&listid='+ encodeURIComponent(encodeURIComponent(bidData.inviteProjectId))
                        +'&periodid='+ encodeURIComponent(encodeURIComponent(bidData.nviteProjectEntryId))
                        +'&creator='+ encodeURIComponent(encodeURIComponent(bidData.supplierId))
                        +'&typeid='+ (isDraft ? draftId : busiUUID)
                        +'&oldtypeid='+ (oldtypeid)"
                ></iframe>
            </template>
            <template v-else>
                <iframe style="width:100%;height:900px;border:1px solid #ccc;" name="iframeA" id="iframeA"
                        :src="'http://10.192.1.6:8082/WebReport/ReportServer?reportlet=ListDahua.cpt&op=write'
                        +'&listid='+ encodeURIComponent(encodeURIComponent(bidData.inviteProjectId))
                        +'&periodid='+ encodeURIComponent(encodeURIComponent(bidData.nviteProjectEntryId))
                        +'&creator='+ encodeURIComponent(encodeURIComponent(bidData.supplierId))
                        +'&typeid='+ (isDraft ? draftId : busiUUID)
                        +'&oldtypeid='+ (oldtypeid)"
                ></iframe>
            </template>

            <el-form class="invite-form" label-width="160px" ref="bidBusiForm" :model="bidBusiForm" :rules="rules">

                <el-row>

                    <el-col :span="12">
                        <el-form-item label="总工期：" prop="totalDays">
                            <el-input size="medium" v-model.number="bidBusiForm.totalDays" clearable><template slot="append">天</template></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-form-item label="商务标附件：" prop="" >
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveBidBusi"
                        :action="uploadApi"
                        :on-success="addBidBusiHandle"
                        :on-error="uploadError"
                        multiple
                        :limit="20"
                        :file-list="bidBusiForm.baseFileList">
                        <el-button size="small" type="primary">商务标上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <div style="width:480px;margin:12px auto;"><el-alert title="请确保已填写并保存上方的数据到最后一步，再进行下列操作！" type="warning" :closable="false" show-icon></el-alert></div>
                <el-button type="primary" :disabled="!buttonFlag" @click="addBidBusi(1)">保存草稿</el-button>
                <el-button type="primary" :disabled="!buttonFlag" @click="addBidBusi()">提 交</el-button>
                <el-button @click="bidBusiDialogShow = false">取 消</el-button>
            </span>

        </el-dialog>

        <el-dialog title="商务标询标" :visible.sync="bidBusiDialogShow2" width="640px" @close="resetForm" center>

            <el-form class="invite-form" label-width="160px" ref="bidBusiForm2" :model="bidBusiForm" :rules="rules">

                <el-row>
                <el-col :span="12">
                <el-form-item label="不含税报价：" prop="noTax">
                <el-input size="medium" v-model.number="bidBusiForm.noTax" clearable><template slot="append">元</template></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="税率：" prop="taxRate">
                <el-input size="medium" v-model.number="bidBusiForm.taxRate" :maxlength="6" clearable><template slot="append">%</template></el-input>
                </el-form-item>
                </el-col>
                </el-row>

                <el-row>

                    <el-col :span="12">
                    <el-form-item label="总报价：" prop="">
                    <el-input size="medium" v-model="priceAll" disabled ><template slot="append">元</template></el-input>
                    </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="总工期：" prop="totalDays">
                            <el-input size="medium" v-model.number="bidBusiForm.totalDays" clearable><template slot="append">天</template></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-form-item label="总报价大写：" prop="">
                <el-input size="medium" v-model="priceAllCaps" disabled></el-input>
                </el-form-item>
                <el-form-item label="报价说明：" prop="" >
                <el-input v-model="bidBusiForm.priceRemark" type="textarea" :maxlength="120" :rows="3" placeholder="请输入内容">
                </el-input>
                </el-form-item>

                <el-form-item label="商务标附件：" prop="" >
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveBidBusi"
                        :action="uploadApi"
                        :on-success="addBidBusiHandle"
                        :on-error="uploadError"
                        multiple
                        :limit="20"
                        :file-list="bidBusiForm.baseFileList">
                        <el-button size="small" type="primary">商务标上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="!buttonFlag" @click="addBidBusi">提 交</el-button>
                <el-button @click="bidBusiDialogShow2 = false">取 消</el-button>
            </span>

        </el-dialog>

        <!-- 三材类商务标询标 -->
        <el-dialog title="商务标询标" :visible.sync="threeReturnShow" width="700px" @close="resetForm" center>
            <div style="border: 1px solid #e4e4e4; padding-left: 3px; margin-bottom: 25px;">
                <h4 style="margin-block-start: 0.2em; margin-block-end: 0.2em;">内网信息</h4>
                <el-row>
                    <el-col :span="5" class="text-right">除税信息价：</el-col>
                    <el-col :span="7">{{bidData.inviteProject.noTaxInfoPrice + " " + bidData.inviteProject.infoPriceUnit}} </el-col>
                    <el-col :span="5" class="text-right">工程量：</el-col>
                    <el-col :span="7"> {{bidData.inviteProject.quantities + " " + bidData.inviteProject.quantitiesUnit}} </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">信息价时间：</el-col>
                    <el-col :span="19"> {{bidData.inviteProject.infoPriceDate}} </el-col>
                </el-row>
            </div>
            <el-form class="invite-form" label-width="160px" ref="threeForm" :model="bidBusiForm">
                <div v-for="(threeOne, i) in bidBusiForm.returnEntryList" :key="i">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="付款比例：" :prop="'returnEntryList.' + i + '.payRate'" :rules="rulesThree.payRate">
                                <el-input size="medium" v-model.number="threeOne.payRate" clearable>
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="除税竞标浮动率：" :prop="'returnEntryList.' + i + '.priceFloatRate'" :rules="rulesThree.priceFloatRate">
                                <el-input size="medium" v-model.number="threeOne.priceFloatRate" :maxlength="6" clearable>
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="报价税率：" :prop="'returnEntryList.' + i + '.taxRate'" :rules="rulesThree.taxRate">
                                <el-input size="medium" v-model.number="threeOne.taxRate" :maxlength="6" clearable>
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="除税报价总额：" :prop="'returnEntryList.' + i + '.noTax'" :rules="rulesThree.noTax">
                                <el-input size="medium" v-model="threeOne.noTax">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <el-form-item>
                    <el-button type="primary" v-if="bidBusiForm.returnEntryList.length < 2" @click="addOrEditEntry(1)">添加付款比例</el-button>
                    <el-button  v-if="bidBusiForm.returnEntryList.length > 1" @click="addOrEditEntry(2)">删除</el-button>
                </el-form-item>

                <el-form-item label="报价说明：" prop="" >
                    <el-input v-model="bidBusiForm.priceRemark" type="textarea" :maxlength="120" :rows="3" placeholder="请输入内容">
                    </el-input>
                </el-form-item>

                <el-form-item label="商务标附件：" prop="" >
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveBidBusi"
                        :action="uploadApi"
                        :on-success="addBidBusiHandle"
                        :on-error="uploadError"
                        multiple
                        :limit="20"
                        :file-list="bidBusiForm.baseFileList">
                        <el-button size="small" type="primary">商务标上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="!buttonFlag" @click="submitThreeForm">提 交</el-button>
                <el-button @click="threeReturnShow = false">取 消</el-button>
            </span>

        </el-dialog>

        <!--  多付款方式      -->
        <muti-pay-dialog ref="mutiPayDialog" :isInviteBid="true" :bidPayCan="bidPayCan" :bidPayCan1="bidPayCan1" :bidPayCan2="bidPayCan2" :pay1="pay1" :pay2="pay2" @formSubmit="mutiPaySubmit"></muti-pay-dialog>

        <el-dialog title="商务标询标详情" :visible.sync="bidBusiDataDialogShow" width="640px" center>
            <el-row>
                <div v-if="bidData.inviteProject.threeSelfType != '1'">
                    <el-row>
                        <el-col :span="4" class="text-right">不含税报价：</el-col><el-col :span="8">{{ bidBusiData.noTax }} 元</el-col>
                        <el-col :span="4" class="text-right">税率：</el-col><el-col :span="8">{{ bidBusiData.taxRate }} %</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4" class="text-right">总报价：</el-col><el-col :span="8">{{ bidBusiData.totalPrice }} 元</el-col>
                        <el-col :span="4" class="text-right">总工期：</el-col><el-col :span="8">{{ bidBusiData.totalDays }} 天</el-col>
                    </el-row>
                    <el-row><el-col :span="4" class="text-right">总报价大写：</el-col><el-col :span="20">{{ bidBusiData.totalPriceCapital }}</el-col></el-row>
                </div>

                <div v-else>
                    <div style="border: 1px solid #e4e4e4; padding-left: 3px;">
                        <h4 style="margin-block-start: 0.2em; margin-block-end: 0.2em;">内网信息</h4>
                        <el-row>
                            <el-col :span="5" class="text-right">除税信息价：</el-col>
                            <el-col :span="7">{{bidData.inviteProject.noTaxInfoPrice + " " + bidData.inviteProject.infoPriceUnit}} </el-col>
                            <el-col :span="5" class="text-right">工程量：</el-col>
                            <el-col :span="7"> {{bidData.inviteProject.quantities + " " + bidData.inviteProject.quantitiesUnit}} </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="5" class="text-right">信息价时间：</el-col>
                            <el-col :span="19"> {{bidData.inviteProject.infoPriceDate}} </el-col>
                        </el-row>
                    </div>
                    <div v-for="(item,i) in bidBusiData.returnEntryList" :key="i">
                        <h4 style="margin-block-start: 0.2em; margin-block-end: 0.2em;">付款信息{{ i + 1 }}</h4>
                        <el-row>
                            <el-col :span="5" class="text-right">付款比例：</el-col>
                            <el-col :span="7">{{ item.payRate }} %</el-col>
                            <el-col :span="5" class="text-right">除税竞标浮动率：</el-col>
                            <el-col :span="7">{{ item.priceFloatRate }} %</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="5" class="text-right">报价税率：</el-col>
                            <el-col :span="7">{{ item.taxRate }} %</el-col>
                            <el-col :span="5" class="text-right">除税报价总额：</el-col>
                            <el-col :span="7">{{ item.noTax }} 元</el-col>
                        </el-row>
                    </div>
                </div>

                <el-row><el-col :span="5" class="text-right">报价说明：</el-col><el-col :span="19">{{ bidBusiData.priceRemark||'无' }}</el-col></el-row>
                <el-row v-if="isStandard">
                    <el-col :span="5" class="text-right">标准清单：</el-col>
                    <el-col :span="19" >
                         <a v-if="iframeUrl" :href="
                            iframeUrl
                            +'&listid='+ encodeURIComponent(encodeURIComponent(bidData.inviteProjectId))
                            +'&periodid='+ encodeURIComponent(encodeURIComponent(bidData.nviteProjectEntryId))
                            +'&creator='+ encodeURIComponent(encodeURIComponent(supplierId))
                            +'&typeid='+ bidBusiData.id
                        " target="_blank">查看详情
                        </a> <!--encodeURIComponent(encodeURIComponent(fid))-->
                        <a v-else :href="
                            'http://10.192.1.6:8082/WebReport/ReportServer?reportlet=ListDahua_View.cpt&op=view'
                            +'&listid='+ encodeURIComponent(encodeURIComponent(bidData.inviteProjectId))
                            +'&periodid='+ encodeURIComponent(encodeURIComponent(bidData.nviteProjectEntryId))
                            +'&creator='+ encodeURIComponent(encodeURIComponent(supplierId))
                            +'&typeid='+ bidBusiData.id
                        " target="_blank">查看详情
                        </a> <!--encodeURIComponent(encodeURIComponent(fid))-->

                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">商务标附件：</el-col>
                    <el-col :span="19">
                        <div v-if="bidBusiData.baseFileList.length==0" class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in bidBusiData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                        </ul>
                    </el-col>
                </el-row>
            </el-row>
        </el-dialog>


        <!-- type 1 -->
        <el-card v-if="type==1" class="box-card">
            <div slot="header" class="clearfix">
                <label>技术标询标记录</label>
                <el-button type="primary" size="mini" :disabled="!buttonFlag" style="float:right;" @click="addTech()">+ 询标</el-button>
            </div>
            <div v-if="bidData.bidReturnList.length==0" class="no-data-tip"></div>
            <ul v-else class="invite-mng-list">
                <li v-for="(li,index) in bidData.bidReturnList"><span style="color: red;margin-right: 20px;">{{li.disReturn}}</span><a @click="showBidTechList(li.id)" href="javascript:;">{{ bidData.inviteProject.fname }} 技术标</a><span v-if="index!=0"  style="float:right;color: red;margin-left: 20px;cursor:pointer" @click="deleteXb(li.id,li.inquiryId)">删除</span><span style="float: right;">{{ li.createDate }}</span></li>
            </ul>
        </el-card>

        <el-dialog title="技术标询标" :visible.sync="bidTechDialogShow" width="640px" @close="resetForm" center>

            技术标附件：

            <el-upload
                class="upload-demo"
                :before-upload="beforeUpload"
                :on-remove="handleRemoveBidTech"
                :action="uploadApi"
                :on-success="addBidTechHandle"
                :on-error="uploadError"
                multiple
                :limit="20"
                :file-list="bidTechForm.baseFileList">
                <el-button size="small" type="primary">技术标上传</el-button>
                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
            </el-upload>

            <span slot="footer" class="dialog-footer">
                <el-button @click="bidTechDialogShow = false">取 消</el-button>
                <el-button type="primary" :disabled="!buttonFlag" @click="addBidTech">提 交</el-button>
            </span>

        </el-dialog>

        <el-dialog title="技术标询标详情" :visible.sync="bidTechDataDialogShow" width="640px" center>
            <el-row>
                <el-col :span="4" class="text-right">技术标附件：</el-col>
                <el-col :span="20">
                    <div v-if="bidTechData.baseFileList.length==0" class="no-data-tip"></div>
                    <ul v-else>
                        <li v-for="li in bidTechData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                    </ul>
                </el-col>
            </el-row>
        </el-dialog>


        <!-- type 2 -->
        <el-card v-if="type==2" class="box-card">
            <div slot="header" class="clearfix">
                <label>投标封样询标记录</label>
                <el-button type="primary" size="mini" :disabled="!buttonFlag" style="float:right;" @click="bidDemoDialogShow = true">+ 询标</el-button>
            </div>
            <div v-if="bidData.bidReturnList.length==0" class="no-data-tip"></div>
            <ul v-else class="invite-mng-list">
                <li v-for="li in bidData.bidReturnList"><a @click="showBidDemoList(li.id)" href="javascript:;">{{ bidData.inviteProject.fname }} 投标封样</a><span style="float: right;">{{ li.createDate }}</span></li>
            </ul>
        </el-card>

        <el-dialog title="投标封样询标" :visible.sync="bidDemoDialogShow" width="640px" @close="resetForm" center>

            <el-form>

                <el-form-item label="解释说明：" prop="" >
                    <el-input v-model="bidDemoForm.remark" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
                </el-form-item>

                附件：

                <el-upload
                    class="upload-demo"
                    :before-upload="beforeUpload"
                    :on-remove="handleRemoveBidDemo"
                    :action="uploadApi"
                    :on-success="addBidDemoHandle"
                    :on-error="uploadError"
                    multiple
                    :limit="20"
                    :file-list="bidDemoForm.baseFileList">
                    <el-button size="small" type="primary">上 传</el-button>
                    <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                        <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                </el-upload>

                <div class="text-center">
                    <el-button type="primary" :disabled="!buttonFlag" @click="addBidDemo">提 交</el-button>
                </div>
            </el-form>

        </el-dialog>

        <el-dialog title="投标封样询标详情" :visible.sync="bidDemoDataDialogShow" width="640px" center>
            <el-row>
                <el-row><el-col :span="4" class="text-right">解释说明：</el-col><el-col :span="20">{{ bidDemoData.remark||'无' }}</el-col></el-row>
                <el-row>
                    <el-col :span="4" class="text-right">附件：</el-col>
                    <el-col :span="20">
                        <div v-if="bidDemoData.baseFileList.length==0" class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in bidDemoData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                        </ul>
                    </el-col>
                </el-row>
            </el-row>
        </el-dialog>



    </div><!-- container-center -->

</template>


<script>

    import banner from '@/assets/imgs/banner_inviteMng.png';
    import util from '@/util';
    import MutiPayDialog from '@/pages/dsp/invite/components/MutiPayDialog'

    export default {
        name: 'invite-bid',
        components: {
            MutiPayDialog
        },
        data () {
            return {

                uploadApi: `${util.baseUrl}rest/api/ftpRmq/rmqUpdate`,
                downloadApi: `${util.baseUrl}rest/file/down`,

                rules: {
                    noTax: [
                        {required: true, message: '必填'},
                        {type:'number', message:'数字'}
                    ],
                    taxRate: [
                        {required: true, message: '必填'},
                        {type:'number', message:'数字'}
                    ],
                    totalDays: [
                        {required: true, message: '必填'},
                        {type:'number', message:'数字'}
                    ]
                },

                supplierId: '',
                inviteProjectId: '',
                nviteProjectEntryId: '',

                fid: this.$route.params.fid,
                pid: this.$route.params.pid,
                type: this.$route.params.type,
                bidData: {
                    bidReturnList: [],
                    inviteProjectEntry: {
                        fcurprojectname: '',
                        fbidnum: ''

                    },
                    baseFileList:[],
                    inviteProject: {}
                },

                // 商务
                inviteCompanyName: window.sessionStorage.getItem('inviteCompanyName'),

                bidBusiDataDialogShow: false,
                bidBusiData: {
                    baseFileList: []
                },
                bidBusiDialogShow: false,
                bidBusiDialogShow2: false,
                bidBusiForm: {
                    taxRate: '',
                    noTax: '',
                    totalDays: '',
                    priceRemark: '',
                    baseFileList: [],
                    returnEntryList: [
                        {}
                    ]
                },
                fwqCurrentTime:'',
                bidDateEnd: false,
                bidPayCan: false,
                draftId: '',
                isDraft: false,
                busiUUID: '',
                isStandard: false,
                oldtypeid:'',

                // 技术
                bidTechDialogShow: false,
                bidTechForm: {
                    baseFileList: []
                },
                bidTechDataDialogShow: false,
                bidTechData: {baseFileList:[]},

                // 投标封样
                bidDemoDataDialogShow: false,
                bidDemoData: {
                    baseFileList: []
                },
                bidDemoDialogShow:false,
                bidDemoForm: {
                    remark: '',
                    baseFileList: []
                },

                iframeUrl:'' , // iframe的动态url
                urlFid: this.$route.params.urlFid,
                buttonFlag: this.$route.params.buttonFlag,
                threeReturnShow: false,
                rulesThree: {
                    payRate: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^([1-9][0-9]{0,1})$/, message: '必须为不大于100的正整数', trigger: 'blur'}
                    ],
                    priceFloatRate: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^(\-|\+)?([1-9][0-9]{0,1})$/, message: '必须为不大于100的正整数或者负整数', trigger: 'blur'}
                    ],
                    taxRate: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^([1-9][0-9]{0,1})$/, message: '必须为不大于100的正整数', trigger: 'blur'}
                    ],
                    noTax: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '必须为整数或小数（最多两位）', trigger: 'blur'}
                    ]
                },
                payStatus:'',
                payStatusDialog: false,
                isTwoPay: '',
                pay1: '',
                pay2: '',
                bidPayCan1:false,
                bidPayCan2:false
            }
        },
        methods: {
            mutiPaySubmit(formData) {
                const loading = this.$loading({lock:true, fullscreen:true, background:'rgba(255,255,255,0.5)'});

                var data = {
                    returnType: 0,
                    bidReturnType: 2,
                    supplierId: this.supplierId,
                    inviteProjectId: this.pid,
                    inquiryId: this.fid,
                    nviteProjectEntryId: this.nviteProjectEntryId,
                }

                this.draftId = '';

                Object.assign(
                    data,
                    formData
                )

                this.$http.post('rest/api/project/tender/create', data).then((res)=>{

                    setTimeout(function(){
                        loading.close();
                    },1000)

                    if(res.data.result) {
                        this.$message({message:'商务标'+(this.isDraft?'保存':'提交')+'成功',type:'success'});
                        setTimeout(function(){
                            location.reload()
                        },1000)
                    } else {
                        if (res.data.message == '付款方式已发生变更，请重新核对后提交'){
                            this.$alert(res.data.message, '', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    // 付款方式
                                    this.$http.post('rest/api/project/tender/getLastPayMethod', {
                                        inviteProjectId: this.pid
                                    }).then((res) => {
                                        if (res.data.result) {
                                            this.isTwoPay  = res.data.value.isTwoPay || '0';
                                            this.pay1 = res.data.value.pay1 || '';
                                            this.pay2 = res.data.value.pay2 || '';
                                            let bidBusiForm = {
                                                taxRate: data.taxRate,
                                                noTax: data.noTax,
                                                totalDays: data.totalDays,
                                                priceRemark: data.priceRemark,
                                                baseFileList: data.baseFileList,
                                                changeType: data.changeType,
                                                priceRatio: data.priceRatio,
                                                returnEntryList: []
                                            }
                                            this.$refs.mutiPayDialog.openDialog(bidBusiForm);
                                        }
                                    })
                                }
                            });

                        }else {
                            this.$message({message:'商务标提交失败: '+ res.data.message,type:'error'});
                        }
                    }
                })
            },
            // 动态获取url
            getUrl(isView){
                // {
                //     "entryId": "标段主键id",
                //     "isView": "0: 修改的操作的 1：查看试图模式"
                // }
                if(this.urlFid){
                    this.$http.post('rest/api/project/tender/getListUrl', {
                        entryId:this.urlFid,
                        isView:isView
                    }).then((res)=>{
                        if(res.data.result) {
                            this.iframeUrl = res.data.value;
                            console.log(this.iframeUrl,888888);
                        }
                    })
                }
            },


            sendFanruan(msg){
                var ifr = document.getElementById('iframeA').contentWindow;
                ifr.postMessage(msg,'*');
            },
            draftBidBusi(li) {
                if (this.isStandard && (this.payStatus == '' || this.payStatus == null)){
                    this.$alert('报价尚未开启，请稍后进行标准清单填报!')
                    return
                }
                if (this.payStatus=='0'||this.payStatus=='2'){
                    this.$alert('此标准清单已有调整,请按照新模板填写!')
                    return;
                }
                this.bidBusiForm.totalDays = li.totalDays
                this.bidBusiForm.baseFileList = li.baseFileList || []
                this.bidBusiForm.baseFileList.forEach(function(data, index){
                    data.name = data.fileOldName
                })
                this.draftId = li.id
                this.isDraft = li.isDraft

                this.getLaseInfoId(function(data){
                    // console.log(data)
                    if (!!data) {
                        this.oldtypeid = data.id
                    } else {
                        this.oldtypeid=''
                    }
                }.bind(this))

                this.bidBusiDialogShow = true;
                this.getUrl(0);
                this.payStatusDialog = true
                this.getPayStatus()
            },
            getUUID() {
                this.$http.post('rest/api/project/tender/getUuid', {
                    inviteProjectId: this.inviteProjectId,
                    nviteProjectEntryId: this.nviteProjectEntryId
                }).then((res)=>{
                    this.busiUUID = res.data.message
                    console.log('[UUID] '+ this.busiUUID)
                })
            },
	        getCurrentTime(){
	            this.$http.get('rest/api/invite/project/getCurrentTimeLong').then((res)=>{
	                this.fwqCurrentTime = res.data.value;
	            })
	        },
	        getLaseInfoId(fn){
	            this.$http.post('rest/api/project/tender/getLaseInfoId',{
				  "supplierId": this.supplierId,
				  "projectId": this.inviteProjectId,
				  "segmentId": this.nviteProjectEntryId,
				  "type": "0"// 0商务标 1技术标 2投标封样
	            }).then((res)=>{

	            	!!fn&&fn(res.data.value)

	            })
	        },
            getPayStatus () {
                if (this.payStatusDialog) {
                    this.$http.post('rest/api/invite/project/pay', {
                        projectId: this.pid
                    }).then((res) => {
                        if (res.data.result) {
                            this.payStatus = res.data.value.payStatus;
                            if (res.data.value.payStatus != '0') {
                                setTimeout(() => {
                                    this.getPayStatus();
                                }, 1000 * 60 * 5)
                            } else {
                                this.$alert('当前标准清单已暂停，请提交已填报数据并关闭页面，稍后重新填报', '提示', {
                                    confirmButtonText: '已知悉',
                                    callback: action => {
                                        this.payStatusDialog = false;
                                    }
                                });
                            }
                        }
                    })
                }

            },
            addbussness(){
	            if(this.bidDateEnd) {
	                this.$message({message:'询标时间已截止',type:'error'});
	                return
	            }
	            if(!this.bidPayCan){
                    this.$message({message:'询标已被淘汰，不可询标',type:'error'});
                    return
                }
				 this.isDraft = false;
				 if(this.isStandard){
                     if (this.payStatus == '' || this.payStatus == null){
                         this.$message({message: '报价尚未开启，请稍后进行标准清单填报', type: 'error'})
                         return
                     }
                     if (this.payStatus=='0') {
                         this.$message({message: '当前标准清单已暂停，请稍后进行填报', type: 'error'})
                         return
                     }
                     if (this.payStatus=='2') {
                         this.$message({message: '此标准清单已有调整，请按照新模板填写', type: 'error'})
                         return
                     }
	            	if (this.bidData.bidReturnList.length > 0) {
                        this.oldtypeid = this.bidData.bidReturnList[0].id

                        if (this.bidData.bidReturnList[0].isDraft == '1') {
                            this.$message({type:'error', message: '标准清单询标存在草稿，请使用草稿！'})
                            return;
                        }

	            	} else {
                        this.getLaseInfoId(function(data){
                            // console.log(data)
                            if (!!data) {
                                this.oldtypeid = data.id
                            } else {
                                this.oldtypeid=''
                            }
                        }.bind(this))
                    }

                    this.getUUID()
                    this.getUrl(0);
                    this.bidBusiDialogShow = true
                     this.payStatusDialog = true
                     this.getPayStatus()
				 } else {
	            	//提交的时候在最后一次提交记录上改
	            	this.getLaseInfoId(data => {
                        if(!!data){
                            this.bidBusiForm={
                                taxRate: data.taxRate,
                                noTax: data.noTax,
                                totalDays: data.totalDays,
                                priceRemark: data.priceRemark,
                                baseFileList: data.baseFileList||[],
                                returnEntryList: (this.bidData.inviteProject.threeSelfType != '1' ? [] : data.returnEntryList)
                            }
                            if(this.bidBusiForm.baseFileList.length>0){
                                this.bidBusiForm.baseFileList.forEach(function(data, index){
                                    data.name = data.fileOldName
                                })
                            }

                        }else{
                            this.bidBusiForm={
                                taxRate: '',
                                noTax: '',
                                totalDays: '',
                                priceRemark: '',
                                baseFileList: [],
                                returnEntryList: (this.bidData.inviteProject.threeSelfType != '1' ? null : [{}])
                            }
                        }

                        if(this.isTwoPay == '1'){
                            let bidBusiForm = {};
                            Object.assign(bidBusiForm, this.bidBusiForm, {'priceRatio': !!data ? data.priceRatio : ''});
                            if(!this.bidPayCan){
                                this.$alert('询标都被淘汰!')
                                return;
                            }
                            console.log(this.bidPayCan,'bidPayCan')
                            console.log(this.bidPayCan1,'bidPayCan1')
                            console.log(this.bidPayCan2,'bidPayCan2')
                            this.$refs.mutiPayDialog.openDialog(bidBusiForm);
                        }else {
                            if(!this.bidPayCan){
                                this.$alert('询标已被淘汰!')
                                return;
                            }
                            (this.bidData.inviteProject.threeSelfType != '1' && (this.bidBusiDialogShow2 = true)) || (this.threeReturnShow = true)
                        }
	            	})
				 }

            },
	        deleteXb (id,iquiryId){
                this.$confirm('您确定要删除该条记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
	                const loading = this.$loading({lock:true, background:'rgba(255,255,255,0.5)'});
	                this.$http.post('rest/api/project/inquiry/deleteQueryReturn', {
	                	  "id": id,
						  "iquiryId": iquiryId
	                }).then((res)=>{
	                    loading.close();
	                    if(res.data.result) {
	                        this.$alert('删除成功!')
	                    	this.getInfo();
	                    } else {
	                        this.$message({message:'Error: 操作失败: '+ res.data.message,type:'error'});
	                    }
	                })

                }).catch(() => {
                    this.$alert('已取消删除')
                })

	        },
            // 上传文件格式验证
            beforeUpload(file){

                if(file.size/1024/1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M','文件过大！',{ type: 'error' })
                    return false
                }

                if(!util.allowUpload(file.name)){
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                    return false
                }
                return true
            },

            uploadError(){
                this.$message({message:'上传出错，请稍后再试。',type:'error'});
            },

            showBidBusiList: function(id) {
                if(this.isTwoPay == '1' && !this.isStandard){
                    this.$http.post('rest/api/project/tender/info?id=' + id).then((res) => {
                        if (res.data.result) {
                            this.$refs['mutiPayDialog'].showDetail(res.data.value);
                        }
                    })
                }else {
                    this.bidBusiDataDialogShow = true;
                    this.$http.post('rest/api/project/tender/info?id='+id).then((res)=>{
                        if(res.data.result) {
                            this.bidBusiData = res.data.value
                        }
                    })
                    this.getUrl(1);
                }

            },
            addBidBusi: function(isDraft) {
                this.isDraft = isDraft;
                if(this.bidBusiForm.totalDays > 9999) {this.$message({message:'总工期时间过长',type:'error'});return;}

                var showedForm = this.isStandard?'bidBusiForm':'bidBusiForm2';

                this.$refs[showedForm].validate((valid) => {

                   if (valid) {

                        const loading = this.$loading({lock:true, fullscreen:true, background:'rgba(255,255,255,0.5)'});

                        if(this.isStandard) {
                            this.sendFanruan('_g().writeReport()');
                        }

                        var data = {
                            returnType: 0,
                            bidReturnType: 2,
                            supplierId: this.supplierId,
                            inviteProjectId: this.pid,
                            inquiryId: this.fid,
                            nviteProjectEntryId: this.nviteProjectEntryId,
                        }

                        if(this.isStandard) {
                            Object.assign(
                                data,
                                {
                                    id: this.draftId || this.busiUUID,
                                    isDraft: (isDraft ? 1 : 0)
                                }
                            )
                        }

                        this.draftId = '';

                        Object.assign(
                            data,
                            this.bidBusiForm,
                            {totalPrice: this.priceAll,totalPriceCapital: this.priceAllCaps}
                        )

                        this.$http.post('rest/api/project/tender/create', data).then((res)=>{

                            setTimeout(function(){
                                loading.close();
                            },1000)

                            if(res.data.result) {
                                this.$message({message:res.data.message,type:'success'});
                                setTimeout(function(){
                                    location.reload()
                                },1000)
                            } else {
                                this.$message({message:'商务标提交失败: '+ res.data.message,type:'error'});
                            }
                        })

                    } else {
                        this.$message({message: '表单填写有误，请注意必填信息是否填写完整（报价、工期等）', type: 'error'})
                        return false;
                    }

               });


            },
            addBidBusiHandle: function(response, file, fileList){
                // if(file.status=='success'){
                this.bidBusiForm.baseFileList  = __getBaseFiles__(file,fileList)
                // }
            },

            showBidTechList: function(id) {
                this.bidTechDataDialogShow = true;
                this.$http.post('rest/api/project/tender/info?id='+id).then((res)=>{
                    if(res.data.result) {
                        this.bidTechData = res.data.value
                    }
                })
            },
            addTech:function(){
	            if(this.bidDateEnd) {
	                this.$message({message:'询标时间已截止',type:'error'});
	                return
	            }
            	this.bidTechDialogShow = true;
            },
            addBidTech: function() {

                var data = {
                    returnType: 1,
                    bidReturnType: 2,
                    supplierId: this.supplierId,
                    inviteProjectId: this.pid,
                    inquiryId: this.fid,
                    nviteProjectEntryId: this.nviteProjectEntryId
                }

                if(this.bidTechForm.baseFileList.length==0) {
                    this.$message({message:'请上传附件',type:'error'});
                    return
                }

                Object.assign(
                    data,
                    this.bidTechForm
                )

                const loading = this.$loading({lock:true, background:'rgba(255,255,255,0.5)'});

                this.$http.post('rest/api/project/tender/create', data).then((res)=>{

                    loading.close();

                    if(res.data.result) {
                        if(this.payStatus != '0'){
                            this.$message({message: '提交成功', type: 'success'})
                        }else{
                            this.$message({message: '当前清单已提交成功，由于清单已调整，请稍后重写填写', type: 'success'})
                        }
                        setTimeout(function(){
                            location.reload()
                        },1000)
                    } else {
                        this.$message({message:'操作失败',type:'error'});
                    }
                })
            },
            addBidTechHandle: function(response, file, fileList){
                // if(file.status=='success'){
                this.bidTechForm.baseFileList = __getBaseFiles__(file,fileList)
                // }
            },

            showBidDemoList: function(id) {
                this.bidDemoDataDialogShow = true;
                this.$http.post('rest/api/project/tender/info?id='+id).then((res)=>{
                    if(res.data.result) {
                        this.bidDemoData = res.data.value;
                    }
                })
            },
            addBidDemo: function() {

                if(this.bidDemoForm.baseFileList.length==0) {
                    this.$message({message:'请上传附件',type:'error'});
                    return
                }

                var data = {
                    returnType: 2,
                    bidReturnType: 2,
                    supplierId: this.supplierId,
                    inviteProjectId: this.pid,
                    inquiryId: this.fid,
                    nviteProjectEntryId: this.nviteProjectEntryId
                }

                Object.assign(
                    data,
                    this.bidDemoForm
                )

                const loading = this.$loading({lock:true, background:'rgba(255,255,255,0.5)'});

                this.$http.post('rest/api/project/tender/create', data).then((res)=>{

                    loading.close();

                    if(res.data.result) {
                        this.$message({message:'提交成功',type:'success'});
                        setTimeout(function(){
                            location.reload()
                        },1000)
                    } else {
                        this.$message({message:'操作失败:'+ res.data.message,type:'error'});
                    }
                })
            },
            addBidDemoHandle: function(response, file, fileList){
                // if(file.status=='success'){
                this.bidDemoForm.baseFileList = __getBaseFiles__(file,fileList)
                // }
            },

            // 上传控件移除集中处理
            handleRemoveBidBusi: function(file, fileList) {
                this.bidBusiForm.baseFileList = this.bidBusiForm.baseFileList.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            handleRemoveBidTech: function(file, fileList) {
                this.bidTechForm.baseFileList = this.bidTechForm.baseFileList.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            handleRemoveBidDemo: function(file, fileList) {
                this.bidDemoForm.baseFileList = this.bidDemoForm.baseFileList.filter(function(f){
                    return f.uid !== file.uid
                });
            },

            resetForm: function() {

                this.managersForm = { manager:'', managers:[], set:false, add:false, segId:'', mgrId:'' }

                this.reconQstForm = {baseFileList:[]};

                this.reconTableForm = {baseFileList:[]};
                this.reconTableCheck = 0;

                this.bidBusiForm = {
                    taxRate: '',
                    noTax: '',
                    totalDays: '',
                    priceRemark: '',
                    baseFileList: [],
                    returnEntryList: [
                        {}
                    ]
                }

                this.bidTechForm = {baseFileList:[]};
            },
            getInfo(){
				// 获取基本信息
	            this.$http.get('rest/api/project/inquiry/info', {
	                params: {
	                    id: this.fid
	                }
	            }).then((res)=>{
	                if(res.data.result) {
	                    this.bidData = res.data.value;

	                    if(!this.bidData.inviteProjectEntry) {
	                        this.bidData.inviteProjectEntry = {
	                            fcurprojectname: this.bidData.inviteProject.fname,
	                            fbidnum: ''
	                        }
	                    }

	                    // 是否是标准清单
	                    this.isStandard = this.bidData.inviteProject.standardList=='1';


	                    // 数据回填
	                    this.bidBusiForm.baseFileList.forEach((data,index)=>{
	                        data.name = data.fileOldName
	                    })
	                    this.bidTechForm.baseFileList.forEach((data,index)=>{
	                        data.name = data.fileOldName
	                    })
	                    this.bidDemoForm.baseFileList.forEach((data,index)=>{
	                        data.name = data.fileOldName
	                    })

	                    this.supplierId = res.data.value.supplierId;
	                    this.inviteProjectId = res.data.value.inviteProjectId;
	                    this.nviteProjectEntryId = res.data.value.nviteProjectEntryId;

	                }
	            })
            },
            addOrEditEntry (type) {
                if (type == 1) {
                    // 添加
                    if (this.bidBusiForm.returnEntryList.length > 1) {
                        this.$message({type: 'error', message: '付款比例最多只能添加两个'})
                        return
                    } else {
                        this.bidBusiForm.returnEntryList.push({})
                    }
                } else {
                    // 删除
                    if (this.bidBusiForm.returnEntryList.length == 1) {
                        this.$message({type: 'error', message: '付款比例最少保留一个'})
                        return
                    } else (
                        this.bidBusiForm.returnEntryList.splice(1, 1)
                    )
                }
            },
            submitThreeForm () {
                this.$refs['threeForm'].validate((valid) => {

                   if (valid) {
                        const loading = this.$loading({lock:true, fullscreen:true, background:'rgba(255,255,255,0.5)'});
                        var data = {
                            returnType: 0,
                            bidReturnType: 2,
                            supplierId: this.supplierId,
                            inviteProjectId: this.pid,
                            inquiryId: this.fid,
                            nviteProjectEntryId: this.nviteProjectEntryId,
                        }

                        this.bidBusiForm.returnEntryList.forEach(temp => {
                            if (Number(temp.priceFloatRate) > 0) {
                                temp.priceFloatRate = '+' + Number(temp.priceFloatRate)
                            } else {
                                temp.priceFloatRate = '' + Number(temp.priceFloatRate)
                            }
                        })

                        this.draftId = '';

                        Object.assign(
                            data,
                            this.bidBusiForm
                        )

                        this.$http.post('rest/api/project/tender/createThree', data).then((res)=>{

                            setTimeout(function(){
                                loading.close();
                            },1000)

                            if(res.data.result) {
                                this.$message({message:'商务标'+(this.isDraft?'保存':'提交')+'成功',type:'success'});
                                setTimeout(function(){
                                    location.reload()
                                },1000)
                            } else {
                                this.$message({message:'商务标提交失败: '+ res.data.message,type:'error'});
                            }
                        })

                    } else {
                        this.$message({message: '表单填写有误，请注意必填信息是否填写完整', type: 'error'})
                        return false;
                    }

               });
            }
        },
        created(){
            this.$root.navs = [{name:'招标管理',path:'/inviteMngList'}]
            this.$root.headImage.src = banner
            this.$http.post('rest/api/invite/project/pay', {
                projectId: this.pid
            }).then((res) => {
                if (res.data.result) {
                    this.payStatus = res.data.value.payStatus;
                }
            })
        },
        mounted () {
			//this.getCurrentTime();
            // 获取基本信息
            this.$http.get('rest/api/project/inquiry/info', {
                params: {
                    id: this.fid
                }
            }).then((res)=>{
                if(res.data.result) {
                    this.bidData = res.data.value;
                    if(!this.bidData.inviteProjectEntry) {
                        this.bidData.inviteProjectEntry = {
                            fcurprojectname: this.bidData.inviteProject.fname,
                            fbidnum: ''
                        }
                    }

                    // 是否是标准清单
                    this.isStandard = this.bidData.inviteProject.standardList=='1';
		            this.$http.get('rest/api/invite/project/getCurrentTimeLong').then((res)=>{
		                this.fwqCurrentTime = res.data.value;
	                    // 询标是否截止
	                    var now = this.fwqCurrentTime;
	                    var end = new Date(this.bidData.inquiryEndDate).getTime();
	                    if(now > end) {
	                        this.bidDateEnd = true;
	                    }
		            })

                    // 付款方式
                    this.$http.post('rest/api/project/tender/getLastPayMethod', {
                        inviteProjectId: this.pid
                    }).then((res) => {
                        if (res.data.result) {
                            this.isTwoPay  = res.data.value.isTwoPay || '0';
                            this.pay1 = res.data.value.pay1 || '';
                            this.pay2 = res.data.value.pay2 || '';
                        }
                    })



                    // 数据回填
                    this.bidBusiForm.baseFileList.forEach((data,index)=>{
                        data.name = data.fileOldName
                    })
                    this.bidTechForm.baseFileList.forEach((data,index)=>{
                        data.name = data.fileOldName
                    })
                    this.bidDemoForm.baseFileList.forEach((data,index)=>{
                        data.name = data.fileOldName
                    })


                    this.supplierId = res.data.value.supplierId;
                    this.inviteProjectId = res.data.value.inviteProjectId;
                    this.nviteProjectEntryId = res.data.value.nviteProjectEntryId;

                    //淘汰询标
                    this.$http.post('rest/api/project/tender/getInquiringFail', {
                        fId: this.inviteProjectId,
                        entryId: this.nviteProjectEntryId,
                        supplierId: this.supplierId
                    }).then((res) => {
                        if (res.data.result) {
                            if('1,1'!= res.data.value){
                                this.bidPayCan  = true;
                                if(res.data.value==null){
                                    this.bidPayCan1 = true;
                                    this.bidPayCan2 = true;
                                }else{
                                    if('0'==res.data.value.split(',')[0]){
                                        this.bidPayCan1 = true;
                                    }
                                    if('0'==res.data.value.split(',')[1]){
                                        this.bidPayCan2 = true;
                                    }
                                }
                            }else{
                                this.bidPayCan1  = false;
                                this.bidPayCan2  = false;
                            }

                        }
                    })

                    this.$root.navs.push(
                        {name:this.bidData.inviteProject.fname ,path:'/inviteMngInfo/'+ encodeURIComponent(this.bidData.inviteProject.fid)},
                        {name:this.bidData.inviteProjectEntry.fcurprojectname + ( this.bidData.inviteProjectEntry.fbidnum ? '-'+ this.bidData.inviteProjectEntry.fbidnum : '' ) , path:''}
                    )
                    this.$root.activeIndex = 'invite'
                    this.$root.isPublic = false

                }
            })

            window.ji = this;
        },
        computed: {
            // 商务标价格计算
            priceAll() {
                return this.bidBusiForm.noTax * (10000 + parseFloat((+this.bidBusiForm.taxRate).toFixed(3)*100) )/10000 ;
            },
            priceAllCaps() {
                return convertCurrency(this.priceAll);
            }
        }
    }

    function __getBaseFiles__(file,fileList){
        let fs = [];
        fileList.forEach(function (item) {
            console.log(item)
            if(item.response){
                let f = item.response.basefiles[0];
                item.bizTableName =  f.bizTableName;
                item.bizTablePkName =  f.bizTablePkName;
                item.bizTablePkValue =  f.bizTablePkValue;
                item.fid =  f.fid;
                item.fileCatagoryId = f.fileCatagoryId;
                item.fileDesc = f.fileDesc;
                item.fileOldName = f.fileOldName;
                item.name = f.fileOldName;
                item.fileName = f.fileName;
                item.filePath = f.filePath;
                item.fileSize = f.fileSize;
                item.fileType = f.fileType;
                item.sort = f.sort;
            }
            fs.push(item);
        });
        console.log(fs);
        return fs
    }

    // 数字转中文人名币大写
    function convertCurrency(currencyDigits) {
// Constants:
        var MAXIMUM_NUMBER = 99999999999.99;
        // Predefine the radix characters and currency symbols for output:
        var CN_ZERO = "零";
        var CN_ONE = "壹";
        var CN_TWO = "贰";
        var CN_THREE = "叁";
        var CN_FOUR = "肆";
        var CN_FIVE = "伍";
        var CN_SIX = "陆";
        var CN_SEVEN = "柒";
        var CN_EIGHT = "捌";
        var CN_NINE = "玖";
        var CN_TEN = "拾";
        var CN_HUNDRED = "佰";
        var CN_THOUSAND = "仟";
        var CN_TEN_THOUSAND = "万";
        var CN_HUNDRED_MILLION = "亿";
        var CN_SYMBOL = "";  // "人民币";
        var CN_DOLLAR = "元";
        var CN_TEN_CENT = "角";
        var CN_CENT = "分";
        var CN_INTEGER = "整";

// Variables:
        var integral;    // Represent integral part of digit number.
        var decimal;    // Represent decimal part of digit number.
        var outputCharacters;    // The output result.
        var parts;
        var digits, radices, bigRadices, decimals;
        var zeroCount;
        var i, p, d;
        var quotient, modulus;

// Validate input string:
        currencyDigits = currencyDigits.toString();
        if (currencyDigits == "") {
            // window.ji && ji.$message({message:"请输入小写金额！",type:'error'});
            return "";
        }
        if (currencyDigits.match(/[^,.\d]/) != null) {
            // window.ji && ji.$message({message:"小写金额含有无效字符！",type:'error'});
            return "";
        }
        if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
            // window.ji && ji.$message({message:"小写金额的格式不正确！",type:'error'});
            return "";
        }

// Normalize the format of input digits:
        currencyDigits = currencyDigits.replace(/,/g, "");    // Remove comma delimiters.
        currencyDigits = currencyDigits.replace(/^0+/, "");    // Trim zeros at the beginning.
        // Assert the number is not greater than the maximum number.
        if (Number(currencyDigits) > MAXIMUM_NUMBER) {
            // window.ji && ji.$message({message:"金额过大，应小于1000亿元！",type:'error'});
            return "";
        }

// Process the coversion from currency digits to characters:
        // Separate integral and decimal parts before processing coversion:
        parts = currencyDigits.split(".");
        if (parts.length > 1) {
            integral = parts[0];
            decimal = parts[1];
            // Cut down redundant decimal digits that are after the second.
            decimal = decimal.substr(0, 2);
        }
        else {
            integral = parts[0];
            decimal = "";
        }
        // Prepare the characters corresponding to the digits:
        digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
        radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
        bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
        decimals = new Array(CN_TEN_CENT, CN_CENT);
        // Start processing:
        outputCharacters = "";
        // Process integral part if it is larger than 0:
        if (Number(integral) > 0) {
            zeroCount = 0;
            for (i = 0; i < integral.length; i++) {
                p = integral.length - i - 1;
                d = integral.substr(i, 1);
                quotient = p / 4;
                modulus = p % 4;
                if (d == "0") {
                    zeroCount++;
                }
                else {
                    if (zeroCount > 0)
                    {
                        outputCharacters += digits[0];
                    }
                    zeroCount = 0;
                    outputCharacters += digits[Number(d)] + radices[modulus];
                }
                if (modulus == 0 && zeroCount < 4) {
                    outputCharacters += bigRadices[quotient];
                    zeroCount = 0;
                }
            }
            outputCharacters += CN_DOLLAR;
        }
        // Process decimal part if there is:
        if (decimal != "") {
            for (i = 0; i < decimal.length; i++) {
                d = decimal.substr(i, 1);
                if (d != "0") {
                    outputCharacters += digits[Number(d)] + decimals[i];
                }
            }
        }
        // Confirm and return the final output string:
        if (outputCharacters == "") {
            outputCharacters = CN_ZERO + CN_DOLLAR;
        }
        if (decimal == "") {
            outputCharacters += CN_INTEGER;
        }
        outputCharacters = CN_SYMBOL + outputCharacters;
        return outputCharacters;
    }

</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    a {color:var(--cMain);}

    ul {padding: 0;margin:0;}
    ul li {list-style:none;}

    ul.invite-mng-list li {padding:14px 12px;font-size:14px;}
    ul.invite-mng-list li {border-bottom:1px dashed #E5E6E5;}
    ul.invite-mng-list li a {color:var(--cTxt1);text-decoration:none;}
    ul.invite-mng-list li a:hover {color:var(--cMain);}

    .box-card {margin:20px 0;}

</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/InviteBid.vue